import { Input, Select, InputNumber, DatePicker, Checkbox } from "antd";
import { manufacturers } from "../manufacturers";
import { ChevronDownIcon } from "components/Icons";
import { searchAndPrependList } from "helpers/DisplayFieldForFacet";
import FormBarcodeHelper from "./formBarcodeHelper";
import { noPrefixOptions } from "helpers/DisplayFieldForFacet";
import BarcodeInput from "./BarcodeInput";
import DutyRatingCapacityInput from "./DutyRatingCapacityInput";
import FacetCheckbox from "./FacetCheckbox";
import FormTagsHelper from "./formTagsHelper";
import LifecycleInterventionInput from "./LifecycleInterventionInput";
import LikelihoodConsequenceRiskField from "./LikelihoodConsequenceRiskField";
import OperatingStatusComboBox from "./OperatingStatusComboBox";
const ratingsDescription = require("../../core/conditionRatingDescription.json");

function formControl({
  type,
  item,
  key,
  step,
  options,
  forceUpdate,
  barcodePrefixes,
  form,
  setFocus,
  onBlurTimeout,
  facetDefinition,
  manufacturerOptions,
  setManufacturerOptions,
  isMandatory,
  isDisabled,
  hasLabel,
  valuePropName,
  label,
  value,
  itemDefinition,
  conditionTags,
}) {
  let formControl = null;
  const arePrefixOptions = noPrefixOptions(barcodePrefixes);
  const ascendingSort = (arr) => arr.sort((a, b) => (a.code < b.code ? -1 : 1));

  switch (type) {
    case "AutoBox":
      formControl = (
        <Select
          suffixIcon={<ChevronDownIcon />}
          showSearch
          allowClear
          disabled={isDisabled}
          defaultActiveFirstOption={false}
          placeholder={facetDefinition.label}
          getPopupContainer={(trigger) => trigger.parentNode}
          onSearch={(val) => {
            if (val.trim().length > 0) {
              searchAndPrependList(setManufacturerOptions, manufacturers, val);
            } else {
              setManufacturerOptions(manufacturers);
            }
          }}
          onFocus={() => setFocus(true)}
          onBlur={() => onBlurTimeout()}
          onClear={() => {
            if (key === 'facets_manufactuer') {

              setManufacturerOptions(manufacturers)
            }
          }}
        >
          {manufacturerOptions?.map((option) => (
            <Select.Option key={option.code} value={option.code}>
              {option.label}
            </Select.Option>
          ))}
        </Select>
      );
      break;
    case "ComboBox":
      formControl = (
        <Select
          suffixIcon={<ChevronDownIcon />}
          showSearch={options.length > 10 ? true : false}
          allowClear={facetDefinition.allowClear === undefined ? true : facetDefinition.allowClear}
          disabled={isDisabled}
          placeholder={facetDefinition.label}
          getPopupContainer={(trigger) => trigger.parentNode}
          filterOption={(inputValue, option) => {
            return (
              option.children
                ?.toLowerCase()
                .includes(inputValue.toLowerCase()) ||
              option.value.toLowerCase().includes(inputValue.toLowerCase())
            );
          }}
          onFocus={() => setFocus(true)}
          onBlur={() => onBlurTimeout()}
          onChange={(reason) => {
            if (key === "facets_condition") {
              form.setFieldsValue({ facets_condition: reason });
              form.setFieldsValue({
                facets_conditionTags: [],
              });
              forceUpdate();
            }
            if (key === "status") {
              forceUpdate();
            }
          }}
        >
          {(key === "facets_refrigerant-type"
            ? ascendingSort(options)
            : options
          )?.map((option) => {
            const displayValue = ratingsDescription[option.code]?.label;
            return (
              <Select.Option key={option.code} value={option.code}>
                {key === "facets_condition"
                  ? `${option.code}: ${displayValue}`
                  : (option.label || option.description)}
              </Select.Option>
            );
          })}
        </Select>
      );
      break;
    case "ComboBoxYear":
      formControl = (
        <DatePicker
          picker="year"
          getPopupContainer={(trigger) => trigger.parentNode}
          disabledDate={(currentDate) => {
            const startDate = new Date("01 January 1000 00:00:00 UTC"); //anydate in 1975 works
            const endDate = new Date();

            return currentDate < startDate || currentDate > endDate;
          }}
          onChange={() => {
            if (key === "facets_install-date") {
              forceUpdate();
            }
          }}
        />
      );
      break;
    case "TextBox":
      formControl = (
        <Input
          placeholder={facetDefinition.label}
          disabled={isDisabled}
          onFocus={() => setFocus(true)}
          onBlur={() => onBlurTimeout()}
        />
      );
      break;
    case "BarcodeBox":
      formControl = (
        <BarcodeInput
          setFocus={setFocus}
          onBlurTimeout={onBlurTimeout}
          inputKey={key}
          form={form}
          forceUpdate={forceUpdate}
        />
      );
      break;

    case "BarcodePreFixBox":
      formControl =
        !item && !arePrefixOptions ? (
          <FormBarcodeHelper
            form={form}
            setFocus={setFocus}
            onBlurTimeout={onBlurTimeout}
            barcodePrefixes={barcodePrefixes}
            forceUpdate={forceUpdate}
          />
        ) : (
          <BarcodeInput
            setFocus={setFocus}
            onBlurTimeout={onBlurTimeout}
            inputKey={key}
            form={form}
            forceUpdate={forceUpdate}
          />
        );
      break;

    case "EditQuantityBox":
    case "QuantityBox":
      isMandatory = false;
      isDisabled = !itemDefinition.allowMultiple && !itemDefinition.virtual;
      formControl = (
        <InputNumber
          value={isDisabled ? 1 : value}
          disabled={isDisabled}
          inputmode="numeric"
          min={1}
          type="number"
          onFocus={() => setFocus(true)}
          onBlur={() => onBlurTimeout()}
        />
      );
      break;
    case "Numeric":
      formControl = (
        <InputNumber
          disabled={isDisabled}
          placeholder={facetDefinition.label}
          inputmode="numeric"
          min={0}
          step={step}
          type="number"
          onFocus={() => setFocus(true)}
          onBlur={() => onBlurTimeout()}
        />
      );
      break;
    case "MultiLineTextBox":
      formControl =
        key === "notes_condition" ? (
          <FormTagsHelper
            setFocus={setFocus}
            onBlurTimeout={onBlurTimeout}
            forceUpdate={forceUpdate}
            form={form}
            item={item}
            tags={conditionTags}
          />
        ) : (
          <Input.TextArea
            onFocus={() => setFocus(true)}
            onBlur={() => onBlurTimeout()}
          />
        );
      break;
    case "CheckBox":
      hasLabel = false;
      valuePropName = "checked";
      formControl = <Checkbox>{label}</Checkbox>;
      break;
    case "DutyRatingCapacityField":
      formControl = (
        <DutyRatingCapacityInput
          disabled={isDisabled}
          setFocus={setFocus}
          onBlurTimeout={onBlurTimeout}
          inputKey={key}
          form={form}
          forceUpdate={forceUpdate}
          minimum={0}
          step={step}
        />
      )
      break;
    case "LifecycleInterventionField":
      formControl = (
        <LifecycleInterventionInput
          inputKey={key}
          form={form}
          forceUpdate={forceUpdate}
        />
      )
      break;
    case "LikelihoodConsequenceRiskField":
      formControl = (
        <LikelihoodConsequenceRiskField
          inputKey={key}
          form={form}
        />
      )
      break;
    case "FacetCheckbox":
      formControl=(
        <FacetCheckbox
          setFocus={setFocus}
          inputKey={key}
          form={form}
          forceUpdate={forceUpdate}
          label={label}
        />
      )
      break;
    case "OperatingStatusComboBox":
      formControl = (
        <OperatingStatusComboBox
          allowClear={facetDefinition.allowClear === undefined ? true : facetDefinition.allowClear}
          disabled={isDisabled}
          form={form}
          inputKey={key}
          options={options}
          placeholder={facetDefinition.label}
          forceUpdate={forceUpdate}
          onBlurTimeout={onBlurTimeout}
          setFocus={setFocus}
        />
      )
      break;
    default:
      break;
  }

  return formControl;
}

export default formControl;
